import {
  useState,
  FocusEvent,
  AnimationEventHandler,
  FormEventHandler,
} from "react";

export type UseAutofillProps = {
  saveData: (value: string) => void;
};

export const useAutofill = ({ saveData }: UseAutofillProps) => {
  const [isAutofilled, setIsAutofilled] = useState(false);

  const detectAutofillByAnimation: AnimationEventHandler<HTMLInputElement> = ({
    animationName,
  }) => {
    if (animationName === "onAutoFillDetected") {
      setIsAutofilled(true);
    }
  };

  const handleBlurWithAutofill = (event: FocusEvent<HTMLInputElement>) => {
    if (!isAutofilled) {
      saveData(event.target.value);
    }
  };

  const saveDataWithAutofill = (value: string) => {
    if (isAutofilled) {
      saveData(value);
      setIsAutofilled(false);
    }
  };

  const handleFocusWithAutofill = () => {
    // Back to normal status if the user fiddles with the field
    if (isAutofilled) {
      setIsAutofilled(false);
    }
  };

  // Here only for Safari 🍏
  const handleInputWithAutofillSafariHack: FormEventHandler<HTMLInputElement> = (
    event
  ) => {
    if ("data" in event.nativeEvent) {
      // Input events with data are not autofills
      setIsAutofilled(false);
      // Input events without data are autofills
    } else if (!isAutofilled) {
      // 🤞 Only Safari doesn't know we are autofilling at this time
      setIsAutofilled(true);
      saveData(event.currentTarget.value);
    }
  };

  return {
    detectAutofillByAnimation,
    handleBlurWithAutofill,
    handleFocusWithAutofill,
    handleInputWithAutofillSafariHack,
    saveDataWithAutofill,
    setIsAutofilled,
  };
};
